module.exports = __webpack_public_path__ + "img/update--bnr-hover.0c16d354.png";